// removed by extract-text-webpack-plugin
module.exports = {"progress":"_3QKNe","target":"KDbqt","value":"msXxp","raised":"_24ROb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Progress.scss
// module id = ./src/components/Page/Progress.scss
// module chunks = 4